import HomeHero from './components/HomeHero';
import HomeStats from './components/HomeStats';
import HomeServiceCards from './components/HomeServiceCards';
import HomeMeetKendrick from './components/HomeMeetKendrick';
import HomeTestimonials from './components/HomeTestimonials';
import HomeNeighborhoods from './components/HomeNeighborhoods';
import HomeGiveaway from './components/HomeGiveaway';
import HomeFinalCta from './components/HomeFinalCta';
import HomeWhyKendrick from './components/HomeWhyKendrick';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white page-enter">
      <HomeHero />
      <HomeStats />
      <HomeServiceCards />
      <HomeMeetKendrick />
      <HomeWhyKendrick />
      <HomeTestimonials />
      <HomeNeighborhoods />
      <HomeGiveaway />
      <HomeFinalCta />
    </div>
  );
}
